import React from 'react';
import { Block } from '../../components/layout';
import ArticlesTemplates from './components/ArticlesTemplates';
import CaseStudiesTemplates from './components/CaseStudiesTemplates';
import EmailSetting from './components/EmailSetting';
import Languages from './components/Languages';

function Settings() {
    return (
        <Block width="100%" height="100%" ml={10} mr={10} pb={16} style={{ overflowY: "auto" }}>
            <Block mt={16} ml={10} mr={10}>
                <Languages />
            </Block>
            <Block mt={16} ml={10} mr={10}>
                <ArticlesTemplates />
            </Block>
            <Block mt={16} ml={10} mr={10}>
                <CaseStudiesTemplates />
            </Block>
            <Block mt={16} ml={10} mr={10}>
                <EmailSetting
                    settingKey="formations"
                    title="Formations"
                    description="Where course signups and satisfaction surveys are sent."
                />
            </Block>
            <Block mt={16} ml={10} mr={10}>
                <EmailSetting
                    settingKey="careers"
                    title="Trabalhe connosco"
                    description="Where applications sent from the careers page are delivered, CV attached."
                />
            </Block>
            <Block mt={16} ml={10} mr={10}>
                <EmailSetting
                    settingKey="whistleblowing"
                    title="Canal de Denúncias"
                    description="Where whistleblowing reports are delivered. Treat this address as confidential."
                />

                <EmailSetting
                    settingKey="demo"
                    title="Pedido de Demonstração"
                    description="Endereço que recebe os pedidos de demonstração submetidos no site."
                />
            </Block>
        </Block >
    );
}

export default Settings;